// extracted by mini-css-extract-plugin
export var borderRadius = "_fo-4";
export var large = "_fo-3";
export var logoContainer = "_fo-0";
export var nameLogo = "_fo-2";
export var small = "_fo-1";